import { render, staticRenderFns } from "./TwilioCallButton.vue?vue&type=template&id=353fb424&scoped=true"
import script from "./TwilioCallButton.vue?vue&type=script&lang=js"
export * from "./TwilioCallButton.vue?vue&type=script&lang=js"
import style0 from "./TwilioCallButton.vue?vue&type=style&index=0&id=353fb424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353fb424",
  null
  
)

export default component.exports